<div class="col-12 d-flex row justify-content-between header-height pt-3 m-0 pr-5 header-left">
  <div>

    <div class="d-flex align-items-center">
      <img class="logo-height" src="/assets/images/logo-cla.png" />
      <img class="place-height pl-4 mt-0" src="/assets/images/place.png" />
      <div class="location-text ellipsis pl-2 mt-1 header-place-text">
        <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                [ngbPopover]="popContentBuildingName" triggers="manual" #p="ngbPopover"
                (click)="openPopover(p);"  placement="bottom"
               style="display: flex;align-items: baseline;">
                <!-- <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link dropdown-input" readonly [(ngModel)]="displayPark"> -->
                <p class="mb-0 mr-1">{{displayPark}}</p>
                <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" style="width: 10%;height: 10%;" />
              </div>
              <ng-template #popContentBuildingName>
                <div class="dashboard-popover12">
                  <div class="d-flex justify-content-between">
                    <div class="pl-3 pt-3 pr-3 pb-3 " style="width: 100%;">
                      <div class="row pb-2 no-wrap-flex" *ngFor="let park of parkDetails;let i =index"
                        (click)="setParkId(park.parkId, park.locationId); openPopover(p)" style="justify-content: space-between;" >
                        <div class="popover-content normal-font pl-3 email-width word-wrap">
                          {{park.parkName}}, {{park.cityName}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
        <!-- <select class="dropdown" (change)="setParkId($event.target.value)">
          <option *ngFor="let park of parkDetails" [value]="park.parkId" [selected]="selectedPark == park.parkId">{{park.parkName}}, {{park.cityName}}</option>
        </select> -->
        <!-- ITPB,<span class="pl-1">Bengaluru</span> -->
      </div>
      <!-- <img class="dropdown-size pl-2" src="/assets/images/Path.png" /> -->
    </div>
  </div>
  <div class="justify-content-end">
    <div class="d-flex header-refreshed-text">
      Last refreshed on {{lastRefreshedTime}}

      <div>
        <span class="badge pointer-link" (click)="toggleNotification()">{{notificationCount}}</span>
        <img src="/assets/images/notification.png" class="pointer-link" loading="lazy" (click)="toggleNotification()" />
      </div>
    </div>
  </div>



</div>
